import React from 'react';
import Icon from '../../../components/AppIcon';

const ChannelTabs = ({ activeChannel, onChannelChange }) => {
  const channels = [
    { id: 'calling', name: 'Cloud Calling', icon: 'Phone', description: 'Traditional calling system' },
    { id: 'ai-dialer', name: 'AI Smart Dialer', icon: 'Brain', description: 'AI-powered intelligent calling', badge: 'NEW' },
    { id: 'email', name: 'Email Campaigns', icon: 'Mail', description: 'Email marketing campaigns' },
    { id: 'sms', name: 'SMS Messaging', icon: 'MessageSquare', description: 'Text message campaigns' },
    { id: 'social', name: 'Social Media', icon: 'Share2', description: 'Social media outreach' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-1 shadow-elevation-1">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-1">
        {channels?.map((channel) => (
          <button
            key={channel?.id}
            onClick={() => onChannelChange(channel?.id)}
            className={`p-4 rounded-md transition-all duration-200 text-left hover-elevation button-press ${
              activeChannel === channel?.id
                ? 'bg-primary text-primary-foreground shadow-elevation-2'
                : 'hover:bg-muted text-muted-foreground hover:text-foreground'
            }`}
          >
            <div className="flex items-center space-x-3 mb-2">
              <Icon 
                name={channel?.icon} 
                size={20} 
                className={activeChannel === channel?.id ? 'text-primary-foreground' : channel?.color}
              />
              <span className="font-medium text-sm lg:text-base">{channel?.name}</span>
            </div>
            <p className={`text-xs ${
              activeChannel === channel?.id ? 'text-primary-foreground/80' : 'text-muted-foreground'
            }`}>
              {channel?.description}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChannelTabs;